import { render } from "./AppNotificationsListView.vue?vue&type=template&id=65e2513b&scoped=true"
import script from "./AppNotificationsListView.vue?vue&type=script&lang=js"
export * from "./AppNotificationsListView.vue?vue&type=script&lang=js"

import "./AppNotificationsListView.vue?vue&type=style&index=0&id=65e2513b&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e2513b"]])

export default __exports__